import { isNumber } from './checks'
import formatCount from './formatCount'

/**
 * Generates a textual representation of the number of centers, formatted based on the count.
 *
 * - Returns an empty string if the input is not a number or if the count is 0
 * - Returns "1 Center" specifically for a count of 1
 * - For counts greater than 1, uses the `formatCount` function to obtain a formatted string
 *   that may include a "+" sign to indicate an approximate number. This formatted number
 *   is then followed by "Centers" in plural form.
 *
 * The function ensures that singular and plural forms are correctly used, and also indicates
 * thresholds for larger numbers.
 *
 * @param {number} count - The number of centers to be formatted into text.
 * @returns {string} - The center count as a formatted string, suitable for display.
 */
export const generateCentersCountText = (count) => {
  if (!isNumber(count) || count === 0) {
    return ''
  }

  if (count === 1) {
    return '1 Center'
  }

  return `${formatCount(count)} Centers`
}
